export default class Brand {
  constructor(props) {
    this.id = props.id;
    this.name = props.name;
    this.kitUrl = props.kitUrl;
  }

  static empty() {
    return new Brand({
      id: null,
      name: null,
    });
  }
}
